export const slugPattern = /^[A-Za-z0-9-_.~]*$/g
